import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import JwtService from "@/core/services/JwtService";
import ApiService from "@/core/services/ApiService";

const routes: Array<RouteRecordRaw> = [
    //-------Auth-------------
    {
        path: "/",
        redirect: (to) => {
            return { path: "/dashboard" };
        },
        component: () => import("@/layouts/AuthLayout.vue"),
        children: [
            {
                path: "/sign-in",
                name: "sign-in",
                component: () =>
                    import(
                        "@/views/crafted/authentication/basic-flow/SignIn.vue"
                    ),
                meta: {
                    pageTitle: "Sign In",
                },
            },
            {
                path: "/sign-in-google",
                name: "sign-in-google",
                component: () =>
                    import(
                        "@/views/crafted/authentication/basic-flow/SignInGoogle.vue"
                    ),
                meta: {
                    pageTitle: "Sign In Google",
                },
            },
            {
                path: "/sign-up",
                name: "sign-up",
                component: () =>
                    import(
                        "@/views/crafted/authentication/basic-flow/SignUp.vue"
                    ),
                meta: {
                    pageTitle: "Sign Up",
                },
            },
            {
                path: "/password-reset",
                name: "password-reset",
                component: () =>
                    import(
                        "@/views/crafted/authentication/basic-flow/PasswordReset.vue"
                    ),
                meta: {
                    pageTitle: "Password reset",
                },
            },
            {
                path: "/password-reset/:token",
                name: "password-reset-submit",
                component: () =>
                    import(
                        "@/views/crafted/authentication/basic-flow/NewPassword.vue"
                    ),
                meta: {
                    pageTitle: "Password reset",
                },
            },
        ],
    },
    {
        path: "/multi-step-sign-up",
        name: "multi-step-sign-up",
        component: () =>
            import("@/views/crafted/authentication/MultiStepSignUp.vue"),
        meta: {
            pageTitle: "Multi-step Sign up",
        },
    },
    {
        path: "/",
        component: () => import("@/layouts/SystemLayout.vue"),
        children: [
            {
                // the 404 route, when none of the above matches
                path: "/404",
                name: "404",
                component: () =>
                    import("@/views/crafted/authentication/Error404.vue"),
                meta: {
                    pageTitle: "Error 404",
                },
            },
            {
                path: "/500",
                name: "500",
                component: () =>
                    import("@/views/crafted/authentication/Error500.vue"),
                meta: {
                    pageTitle: "Error 500",
                },
            },
        ],
    },
    {
        path: "/:pathMatch(.*)*",
        redirect: "/404",
    },
    //-----------Afiliator--------------------
    {
        path: "/",
        component: () => import("@/layouts/AfiliatorLayout.vue"),
        children: [
            {
                path: "afiliator",
                name: "afiliator",
                component: () => import("@/views/afiliator/index.vue"),
                meta: {
                    pageTitle: "Afiliator",
                },
            },
            {
                path: "afiliator/:id",
                name: "afiliator-view",
                component: () => import("@/views/afiliator/view.vue"),
                meta: {
                    pageTitle: "View Afiliator",
                },
            },
        ]
    },
    //-----------After Login--------------------
    {
        path: "/",
        redirect: "/dashboard",
        component: () => import("@/layouts/main-layout/MainLayout.vue"),
        meta: {
            middleware: "auth",
        },
        children: [
            {
                path: "/dashboard",
                name: "dashboard",
                component: () => import("@/views/Dashboard.vue"),
                meta: {
                    pageTitle: "Dashboard",
                    breadcrumbs: ["Dashboards"],
                },
            },
            {
                path: "/verify-email",
                name: "verify-email",
                component: () => import("@/views/VerifyEmail.vue"),
                meta: {
                    pageTitle: "Email Verifikasi",
                    breadcrumbs: ["Email Verifikasi"],
                },
            },
            {
                path: "/verify-email/:id",
                name: "verify-email-proccess",
                component: () => import("@/views/VerifyEmail.vue"),
                meta: {
                    pageTitle: "Email Verifikasi",
                    breadcrumbs: ["Email Verifikasi"],
                },
            },
            {
                path: "/account",
                name: "account",
                component: () => import("@/views/crafted/account/Account.vue"),
                meta: {
                    breadcrumbs: ["Crafted", "Account"],
                },
                children: [
                    {
                        path: "overview",
                        name: "account-overview",
                        component: () =>
                            import("@/views/crafted/account/Overview.vue"),
                        meta: {
                            pageTitle: "Preview",
                        },
                    },
                    {
                        path: "berkas",
                        name: "account-berkas",
                        component: () =>
                            import("@/views/crafted/account/berkas.vue"),
                        meta: {
                            pageTitle: "Berkas",
                        },
                    },
                    {
                        path: "sim",
                        name: "account-sim",
                        component: () =>
                            import("@/views/crafted/account/sim.vue"),
                        meta: {
                            pageTitle: "SIM Mahasiswa",
                        },
                    },
                    {
                        path: "settings",
                        name: "account-settings",
                        component: () =>
                            import("@/views/crafted/account/Settings.vue"),
                        meta: {
                            pageTitle: "Profil Lengkap",
                        },
                    },
                    {
                        path: "pendidikan-terakhir",
                        name: "account-pendidikan-terakhir",
                        component: () =>
                            import(
                                "@/views/crafted/account/pendidikanTerakhir.vue"
                            ),
                        meta: {
                            pageTitle: "Pendidikan Terakhir",
                        },
                    },
                    {
                        path: "kuesioner",
                        name: "account-kuesioner",
                        component: () =>
                            import("@/views/crafted/account/kuesioner.vue"),
                        meta: {
                            pageTitle: "Kuesioner Singkat",
                        },
                    },
                ],
            },
            //-------pendaftaran-----------
            {
                path: "/pendaftaran",
                name: "pendaftaran",
                component: () => import("@/views/pendaftaran/index.vue"),
                meta: {
                    pageTitle: "Pendaftaran",
                    breadcrumbs: ["Pendaftaran"],
                    permission: "pendaftaran-view",
                },
            },
            {
                path: "/pendaftaran/create",
                name: "pendaftaran-create",
                component: () => import("@/views/pendaftaran/form.vue"),
                meta: {
                    pageTitle: "Pendaftaran",
                    breadcrumbs: ["Pendaftaran", "Daftar"],
                    permission: "pendaftaran-create",
                },
            },
            {
                path: "/pendaftaran/voucher/:id",
                name: "pendaftaran-voucher",
                component: () => import("@/views/pendaftaran/voucher.vue"),
                meta: {
                    pageTitle: "Input Voucher Pendaftaran",
                    breadcrumbs: ["Pendaftaran", "Voucher"],
                    permission: "pendaftaran-voucher",
                },
            },
            {
                path: "/pendaftaran/:id",
                name: "pendaftaran-view",
                component: () => import("@/views/pendaftaran/view.vue"),
                meta: {
                    pageTitle: "Detail Pendaftaran",
                    breadcrumbs: ["Pendaftaran", "Detail"],
                    permission: "pendaftaran-view",
                },
            },
            {
                path: "/pendaftaran/:id/program",
                name: "pendaftaran-program-create",
                component: () => import("@/views/pendaftaran/program/form.vue"),
                meta: {
                    pageTitle: "Pendaftaran Program",
                    breadcrumbs: ["Pendaftaran", "Program"],
                    permission: "pendaftaran-create",
                },
            },
            {
                path: "/master/prodi/:id/program/:idDetail",
                name: "pendaftaran-program-edit",
                component: () => import("@/views/pendaftaran/program/form.vue"),
                meta: {
                    pageTitle: "Edit Pendaftaran Program",
                    breadcrumbs: ["Pendaftaran", "Program"],
                    permission: "pendaftaran-edit",
                },
            },
            {
                path: "/pendaftaran/:id/pembayaran",
                name: "pendaftaran-pembayaran-create",
                component: () =>
                    import("@/views/pendaftaran/pembayaran/form.vue"),
                meta: {
                    pageTitle: "Pembayaran Uang Kuliah",
                    breadcrumbs: ["Pendaftaran", "Pembayaran Uang Kuliah"],
                    permission: "pendaftaran-create",
                },
            },
            {
                path: "/pendaftaran/:id/file",
                name: "pendaftaran-file-create",
                component: () => import("@/views/pendaftaran/file/form.vue"),
                meta: {
                    pageTitle: "Pendaftaran Upload File",
                    breadcrumbs: ["Pendaftaran", "Upload File"],
                    permission: "pendaftaran-create",
                },
            },
            {
                path: "/master/prodi/:id/file/:idDetail",
                name: "pendaftaran-file-edit",
                component: () => import("@/views/pendaftaran/file/form.vue"),
                meta: {
                    pageTitle: "Edit Pendaftaran Upload File",
                    breadcrumbs: ["Pendaftaran", "Upload File"],
                    permission: "pendaftaran-edit",
                },
            },
            //-------konfirmasi kelulusan-----------
            {
                path: "/konfirmasi-kelulusan",
                name: "konfirmasi-kelulusan",
                component: () =>
                    import("@/views/konfirmasi-kelulusan/index.vue"),
                meta: {
                    pageTitle: "Konfirmasi Kelulusan",
                    breadcrumbs: ["Konfirmasi Kelulusan"],
                    permission: "konfirmasi-kelulusan-view",
                },
            },
            //-------pindah prodi-----------
            {
                path: "/pindah-prodi",
                name: "pindah-prodi",
                component: () =>
                    import("@/views/pindah-prodi/index.vue"),
                meta: {
                    pageTitle: "Pindah Prodi",
                    breadcrumbs: ["Pindah Prodi"],
                    permission: "pindah-prodi-view",
                },
            },
            //-------kirim informasi-----------
            {
                path: "/kirim-informasi",
                children: [
                    {
                        path: "pendaftaran",
                        name: "kirim-informasi-pendaftaran",
                        component: () => import("@/views/kirim-informasi/pendaftaran/index.vue"),
                        meta: {
                            pageTitle: "Kirim Informasi Pendaftaran",
                            breadcrumbs: ["Kirim Informasi Pendaftaran"],
                            permission: "kirim-informasi-view",
                        },
                    },
                    {
                        path: "file-excel",
                        name: "kirim-informasi-file-excel",
                        component: () => import("@/views/kirim-informasi/file-excel/index.vue"),
                        meta: {
                            pageTitle: "Kirim Informasi File Excel",
                            breadcrumbs: ["Kirim Informasi File Excel"],
                            permission: "kirim-informasi-file-excel",
                        },
                    },
                ]
            },
            //-------Import nilai cbt-----------
            {
                path: "/import-nilai-cbt",
                name: "import-nilai-cbt",
                component: () => import("@/views/import-nilai-cbt/form.vue"),
                meta: {
                    pageTitle: "Import Nilai CBT",
                    breadcrumbs: ["Import Nilai CBT"],
                    permission: "import-nilai-cbt-view",
                },
            },
            //-------url-----------
            {
                path: "/settings/url",
                name: "settings-url",
                component: () => import("@/views/settings/url/index.vue"),
                meta: {
                    pageTitle: "Setting Url",
                    breadcrumbs: ["Settings", "Url"],
                    permission: "settings-url-view",
                },
            },
            {
                path: "/settings/url/create",
                name: "settings-url-create",
                component: () => import("@/views/settings/url/form.vue"),
                meta: {
                    pageTitle: "Create Setting Url",
                    breadcrumbs: ["Settings", "Url", "Create"],
                    permission: "settings-url-create",
                },
            },
            {
                path: "/settings/url/:id",
                name: "settings-url-edit",
                component: () => import("@/views/settings/url/form.vue"),
                meta: {
                    pageTitle: "Edit Settings Url",
                    breadcrumbs: ["Settings", "Url", "Edit"],
                    permission: "settings-url-update",
                },
            },
            //-------accounts-----------
            {
                path: "/settings/accounts",
                name: "settings-accounts",
                component: () => import("@/views/settings/accounts/index.vue"),
                meta: {
                    pageTitle: "Setting Akun",
                    breadcrumbs: ["Settings", "Akun"],
                    permission: "settings-accounts-view",
                },
            },
            {
                path: "/settings/accounts/create",
                name: "settings-accounts-create",
                component: () => import("@/views/settings/accounts/form.vue"),
                meta: {
                    pageTitle: "Create Setting Akun",
                    breadcrumbs: ["Settings", "Akun", "Create"],
                    permission: "settings-accounts-create",
                },
            },
            {
                path: "/settings/accounts/:id",
                name: "settings-accounts-edit",
                component: () => import("@/views/settings/accounts/form.vue"),
                meta: {
                    pageTitle: "Edit Settings Akun",
                    breadcrumbs: ["Settings", "Akun", "Edit"],
                    permission: "settings-accounts-update",
                },
            },
            //-------permissions-----------
            {
                path: "/settings/permissions",
                name: "settings-permissions",
                component: () =>
                    import("@/views/settings/permissions/index.vue"),
                meta: {
                    pageTitle: "Setting Permissions",
                    breadcrumbs: ["Settings", "Permissions"],
                    permission: "settings-permissions-view",
                },
            },
            {
                path: "/settings/permissions/create",
                name: "settings-permissions-create",
                component: () =>
                    import("@/views/settings/permissions/form.vue"),
                meta: {
                    pageTitle: "Create Setting Permissions",
                    breadcrumbs: ["Settings", "Permissions", "Create"],
                    permission: "settings-permissions-create",
                },
            },
            {
                path: "/settings/permissions/:id",
                name: "settings-permissions-edit",
                component: () =>
                    import("@/views/settings/permissions/form.vue"),
                meta: {
                    pageTitle: "Edit Settings Permissions",
                    breadcrumbs: ["Settings", "Permissions", "Edit"],
                    permission: "settings-permissions-update",
                },
            },
            //-------roles-----------
            {
                path: "/settings/roles",
                name: "settings-roles",
                component: () => import("@/views/settings/roles/index.vue"),
                meta: {
                    pageTitle: "Setting Roles",
                    breadcrumbs: ["Settings", "Roles"],
                    permission: "settings-roles-view",
                },
            },
            {
                path: "/settings/roles/create",
                name: "settings-roles-create",
                component: () => import("@/views/settings/roles/form.vue"),
                meta: {
                    pageTitle: "Create Setting Roles",
                    breadcrumbs: ["Settings", "Roles", "Create"],
                    permission: "settings-roles-create",
                },
            },
            {
                path: "/settings/roles/:id",
                name: "settings-roles-edit",
                component: () => import("@/views/settings/roles/form.vue"),
                meta: {
                    pageTitle: "Edit Settings Roles",
                    breadcrumbs: ["Settings", "Roles", "Edit"],
                    permission: "settings-roles-update",
                },
            },
            {
                path: "/settings/roles/menus/:id",
                name: "settings-roles-menus",
                component: () => import("@/views/settings/roles/menus.vue"),
                meta: {
                    pageTitle: "Setting Roles Menus",
                    breadcrumbs: ["Settings", "Roles", "Menus"],
                    permission: "settings-roles-menus",
                },
            },
            {
                path: "/settings/roles/permissions/:id",
                name: "settings-roles-permissions",
                component: () =>
                    import("@/views/settings/roles/permissions.vue"),
                meta: {
                    pageTitle: "Setting Roles Permissions",
                    breadcrumbs: ["Settings", "Roles", "Permissions"],
                    permission: "settings-roles-permissions",
                },
            },
            //-------whatsapp-----------
            {
                path: "/settings/whatsapp",
                name: "settings-whatsapp",
                component: () => import("@/views/settings/whatsapp/index.vue"),
                meta: {
                    pageTitle: "Setting WhatsApp",
                    breadcrumbs: ["Settings", "WhatsApp"],
                    permission: "settings-whatsapp-view",
                },
            },
            {
                path: "/settings/whatsapp/create",
                name: "settings-whatsapp-create",
                component: () => import("@/views/settings/whatsapp/form.vue"),
                meta: {
                    pageTitle: "Create Setting WhatsApp",
                    breadcrumbs: ["Settings", "WhatsApp", "Create"],
                    permission: "settings-whatsapp-create",
                },
            },
            {
                path: "/settings/whatsapp/:id",
                name: "settings-whatsapp-edit",
                component: () => import("@/views/settings/whatsapp/form.vue"),
                meta: {
                    pageTitle: "Edit Settings WhatsApp",
                    breadcrumbs: ["Settings", "WhatsApp", "Edit"],
                    permission: "settings-whatsapp-update",
                },
            },
            {
                path: "/settings/whatsapp/:id/view",
                name: "settings-whatsapp-view",
                component: () => import("@/views/settings/whatsapp/view.vue"),
                meta: {
                    pageTitle: "Connect WhatsApp",
                    breadcrumbs: ["Connect", "WhatsApp"],
                    permission: "settings-whatsapp-update",
                },
            },
            //-------fakultas-----------
            {
                path: "/master/fakultas",
                name: "master-fakultas",
                component: () => import("@/views/master/fakultas/index.vue"),
                meta: {
                    pageTitle: "Master Fakultas",
                    breadcrumbs: ["Master", "Fakultas"],
                    permission: "master-fakultas-view",
                },
            },
            {
                path: "/master/fakultas/create",
                name: "master-fakultas-create",
                component: () => import("@/views/master/fakultas/form.vue"),
                meta: {
                    pageTitle: "Create Master Fakultas",
                    breadcrumbs: ["master", "Fakultas", "Create"],
                    permission: "master-fakultas-create",
                },
            },
            {
                path: "/master/fakultas/:id",
                name: "master-fakultas-edit",
                component: () => import("@/views/master/fakultas/form.vue"),
                meta: {
                    pageTitle: "Edit Master Fakultas",
                    breadcrumbs: ["Master", "Fakultas", "Edit"],
                    permission: "master-fakultas-update",
                },
            },
            //-------jenjang-----------
            {
                path: "/master/jenjang",
                name: "master-jenjang",
                component: () => import("@/views/master/jenjang/index.vue"),
                meta: {
                    pageTitle: "Master Jenjang",
                    breadcrumbs: ["Master", "Jenjang"],
                    permission: "master-jenjang-view",
                },
            },
            {
                path: "/master/jenjang/create",
                name: "master-jenjang-create",
                component: () => import("@/views/master/jenjang/form.vue"),
                meta: {
                    pageTitle: "Create Master Jenjang",
                    breadcrumbs: ["master", "Jenjang", "Create"],
                    permission: "master-jenjang-create",
                },
            },
            {
                path: "/master/jenjang/:id",
                name: "master-jenjang-edit",
                component: () => import("@/views/master/jenjang/form.vue"),
                meta: {
                    pageTitle: "Edit Master Jenjang",
                    breadcrumbs: ["Master", "Jenjang", "Edit"],
                    permission: "master-jenjang-update",
                },
            },
            //-------jenjang-pendaftaran-----------
            {
                path: "/master/jenjang-pendaftaran",
                name: "master-jenjang-pendaftaran",
                component: () =>
                    import("@/views/master/jenjang-pendaftaran/index.vue"),
                meta: {
                    pageTitle: "Master Jenjang-pendaftaran",
                    breadcrumbs: ["Master", "Jenjang Pendaftaran"],
                    permission: "master-jenjang-pendaftaran-view",
                },
            },
            {
                path: "/master/jenjang-pendaftaran/create",
                name: "master-jenjang-pendaftaran-create",
                component: () =>
                    import("@/views/master/jenjang-pendaftaran/form.vue"),
                meta: {
                    pageTitle: "Create Master Jenjang-pendaftaran",
                    breadcrumbs: ["master", "Jenjang Pendaftaran", "Create"],
                    permission: "master-jenjang-pendaftaran-create",
                },
            },
            {
                path: "/master/jenjang-pendaftaran/:id",
                name: "master-jenjang-pendaftaran-edit",
                component: () =>
                    import("@/views/master/jenjang-pendaftaran/form.vue"),
                meta: {
                    pageTitle: "Edit Master Jenjang-pendaftaran",
                    breadcrumbs: ["Master", "Jenjang Pendaftaran", "Edit"],
                    permission: "master-jenjang-pendaftaran-update",
                },
            },
            //-------prodi-----------
            {
                path: "/master/prodi",
                name: "master-prodi",
                component: () => import("@/views/master/prodi/index.vue"),
                meta: {
                    pageTitle: "Master Prodi",
                    breadcrumbs: ["Master", "Prodi"],
                    permission: "master-prodi-view",
                },
            },
            {
                path: "/master/prodi/create",
                name: "master-prodi-create",
                component: () => import("@/views/master/prodi/form.vue"),
                meta: {
                    pageTitle: "Create Master Prodi",
                    breadcrumbs: ["master", "Prodi", "Create"],
                    permission: "master-prodi-create",
                },
            },
            {
                path: "/master/prodi/:id",
                name: "master-prodi-edit",
                component: () => import("@/views/master/prodi/form.vue"),
                meta: {
                    pageTitle: "Edit Master Prodi",
                    breadcrumbs: ["Master", "Prodi", "Edit"],
                    permission: "master-prodi-update",
                },
            },
            {
                path: "/master/prodi/view/:id",
                name: "master-prodi-view",
                component: () => import("@/views/master/prodi/view.vue"),
                meta: {
                    pageTitle: "View Master Prodi",
                    breadcrumbs: ["Master", "Prodi", "View"],
                    permission: "master-prodi-view",
                },
            },
            {
                path: "/master/prodi/:id/create",
                name: "create-prodi-detail",
                component: () => import("@/views/master/prodi/detail/form.vue"),
                meta: {
                    pageTitle: "Tambah Detail Prodi",
                    breadcrumbs: ["Detail", "prodi", "Create"],
                    permission: "master-prodi-detail-create",
                },
            },
            {
                path: "/master/prodi/:id/edit/:idDetail",
                name: "edit-prodi-detail",
                component: () => import("@/views/master/prodi/detail/form.vue"),
                meta: {
                    pageTitle: "Edit Detail Prodi",
                    breadcrumbs: ["Detail", "Prodi", "Edit"],
                    permission: "master-prodi-detail-edit",
                },
            },
            {
                path: "/master/prodi/:id/create-uang-kuliah",
                name: "create-uang-kuliah",
                component: () =>
                    import("@/views/master/prodi/uang-kuliah/form.vue"),
                meta: {
                    pageTitle: "Tambah Uang Kuliah",
                    breadcrumbs: ["Tambah", "Uang Kuliah", "Create"],
                    permission: "master-uang-kuliah-create",
                },
            },
            {
                path: "/master/prodi/:id/edit-uang-kuliah/:idDetail",
                name: "edit-uang-kuliah",
                component: () =>
                    import("@/views/master/prodi/uang-kuliah/form.vue"),
                meta: {
                    pageTitle: "Edit Uang Kuliah",
                    breadcrumbs: ["Edit", "Uang Kuliah", "Edit"],
                    permission: "master-uang-kuliah-edit",
                },
            },
            //-------program-----------
            {
                path: "/master/program",
                name: "master-program",
                component: () => import("@/views/master/program/index.vue"),
                meta: {
                    pageTitle: "Master Program",
                    breadcrumbs: ["Master", "Program"],
                    permission: "master-program-view",
                },
            },
            {
                path: "/master/program/create",
                name: "master-program-create",
                component: () => import("@/views/master/program/form.vue"),
                meta: {
                    pageTitle: "Create Master Program",
                    breadcrumbs: ["master", "Program", "Create"],
                    permission: "master-program-create",
                },
            },
            {
                path: "/master/program/:id",
                name: "master-program-edit",
                component: () => import("@/views/master/program/form.vue"),
                meta: {
                    pageTitle: "Edit Master Program",
                    breadcrumbs: ["Master", "Program", "Edit"],
                    permission: "master-program-update",
                },
            },
            //-------jalur-----------
            {
                path: "/master/jalur",
                name: "master-jalur",
                component: () => import("@/views/master/jalur/index.vue"),
                meta: {
                    pageTitle: "Master Jalur",
                    breadcrumbs: ["Master", "Jalur"],
                    permission: "master-jalur-view",
                },
            },
            {
                path: "/master/jalur/create",
                name: "master-jalur-create",
                component: () => import("@/views/master/jalur/form.vue"),
                meta: {
                    pageTitle: "Create Master Jalur",
                    breadcrumbs: ["master", "Jalur", "Create"],
                    permission: "master-jalur-create",
                },
            },
            {
                path: "/master/jalur/:id",
                name: "master-jalur-edit",
                component: () => import("@/views/master/jalur/form.vue"),
                meta: {
                    pageTitle: "Edit Master Jalur",
                    breadcrumbs: ["Master", "Jalur", "Edit"],
                    permission: "master-jalur-update",
                },
            },
            {
                path: "/master/jalur/view/:id",
                name: "master-jalur-view",
                component: () => import("@/views/master/jalur/view.vue"),
                meta: {
                    pageTitle: "View Master Jalur",
                    breadcrumbs: ["Master", "Jalur", "View"],
                    permission: "master-jalur-update",
                },
            },
            {
                path: "/master/jalur/:id/create-jalur-file",
                name: "create-jalur-file",
                component: () => import("@/views/master/jalur/file/form.vue"),
                meta: {
                    pageTitle: "Tambah Jenis File",
                    breadcrumbs: ["Tambah", "Jenis File", "Create"],
                    permission: "master-jalur-create",
                },
            },
            {
                path: "/master/jalur/:id/edit-jalur-file/:idDetail",
                name: "edit-jalur-file",
                component: () => import("@/views/master/jalur/file/form.vue"),
                meta: {
                    pageTitle: "Edit Jenis File",
                    breadcrumbs: ["Edit", "Jenis File", "Edit"],
                    permission: "master-jalur-edit",
                },
            },
            {
                path: "/master/jalur/:id/create",
                name: "create-jalur-detail",
                component: () => import("@/views/master/jalur/detail/form.vue"),
                meta: {
                    pageTitle: "Tambah Detail jalur",
                    breadcrumbs: ["Detail", "jalur", "Create"],
                    permission: "master-jalur-detail-create",
                },
            },
            {
                path: "/master/jalur/:id/edit/:idDetail",
                name: "edit-jalur-detail",
                component: () => import("@/views/master/jalur/detail/form.vue"),
                meta: {
                    pageTitle: "Edit Detail jalur",
                    breadcrumbs: ["Detail", "jalur", "Edit"],
                    permission: "master-jalur-detail-edit",
                },
            },
            //-------provinsi-----------
            {
                path: "/master/provinsi",
                name: "master-provinsi",
                component: () => import("@/views/master/provinsi/index.vue"),
                meta: {
                    pageTitle: "Master provinsi",
                    breadcrumbs: ["Master", "provinsi"],
                    permission: "master-provinsi-view",
                },
            },
            {
                path: "/master/provinsi/create",
                name: "master-provinsi-create",
                component: () => import("@/views/master/provinsi/form.vue"),
                meta: {
                    pageTitle: "Create Master Provinsi",
                    breadcrumbs: ["master", "Provinsi", "Create"],
                    permission: "master-provinsi-create",
                },
            },
            {
                path: "/master/provinsi/:id",
                name: "master-provinsi-edit",
                component: () => import("@/views/master/provinsi/form.vue"),
                meta: {
                    pageTitle: "Edit Master Provinsi",
                    breadcrumbs: ["Master", "Provinsi", "Edit"],
                    permission: "master-provinsi-update",
                },
            },
            {
                path: "/master/provinsi/view/:id",
                name: "master-provinsi-view",
                component: () => import("@/views/master/provinsi/view.vue"),
                meta: {
                    pageTitle: "View Master Provinsi",
                    breadcrumbs: ["Master", "Provinsi", "View"],
                    permission: "master-provinsi-update",
                },
            },
            //---kota
            {
                path: "/master/provinsi/:id/create",
                name: "create-provinsi-kota",
                component: () => import("@/views/master/provinsi/kota/form.vue"),
                meta: {
                    pageTitle: "Tambah Kota / Kabupaten",
                    breadcrumbs: ["Master", "Provinsi", "Kota / Kabupaten", "Tambah"],
                    permission: "master-provinsi-create",
                },
            },
            {
                path: "/master/provinsi/:id/edit-kota/:idKota",
                name: "edit-provinsi-kota",
                component: () => import("@/views/master/provinsi/kota/form.vue"),
                meta: {
                    pageTitle: "Ubah Kota / Kabupaten",
                    breadcrumbs: ["Master", "Provinsi", "Kota / Kabupaten", "Ubah"],
                    permission: "master-provinsi-update",
                },
            },
            {
                path: "/master/kota/view/:id",
                name: "view-provinsi-kota",
                component: () => import("@/views/master/provinsi/kota/view.vue"),
                meta: {
                    pageTitle: "View Kota / Kabupaten",
                    breadcrumbs: ["Master", "Provinsi", "Kota / Kabupaten", "View"],
                    permission: "master-provinsi-view",
                },
            },
            //---kecamatan
            {
                path: "/master/kota/:id/create",
                name: "create-kota-kecamatan",
                component: () => import("@/views/master/provinsi/kecamatan/form.vue"),
                meta: {
                    pageTitle: "Tambah Kecamatan",
                    breadcrumbs: ["Master", "Provinsi", "Kota / Kabupaten", "Kecamatan", "Tambah"],
                    permission: "master-provinsi-create",
                },
            },
            {
                path: "/master/kota/:id/edit-kecamatan/:idKecamatan",
                name: "edit-kota-kecamatan",
                component: () => import("@/views/master/provinsi/kecamatan/form.vue"),
                meta: {
                    pageTitle: "Ubah Kecamatan",
                    breadcrumbs: ["Master", "Provinsi", "Kota / Kabupaten", "Kecamatan", "Ubah"],
                    permission: "master-provinsi-update",
                },
            },
            {
                path: "/master/kecamatan/view/:id",
                name: "view-kota-kecamatan",
                component: () => import("@/views/master/provinsi/kecamatan/view.vue"),
                meta: {
                    pageTitle: "View Kecamatan",
                    breadcrumbs: ["Master", "Provinsi", "Kota / Kabupaten", "Kecamatan", "View"],
                    permission: "master-provinsi-view",
                },
            },
            //---kelurahan
            {
                path: "/master/kecamatan/:id/create",
                name: "create-kecamatan-kelurahan",
                component: () => import("@/views/master/provinsi/kelurahan/form.vue"),
                meta: {
                    pageTitle: "Tambah Kelurahan",
                    breadcrumbs: ["Master", "Provinsi", "Kota / Kabupaten", "Kecamatan", "Kelurahan", "Tambah"],
                    permission: "master-provinsi-create",
                },
            },
            {
                path: "/master/kecamatan/:id/edit-kelurahan/:idKelurahan",
                name: "edit-kecamatan-kelurahan",
                component: () => import("@/views/master/provinsi/kelurahan/form.vue"),
                meta: {
                    pageTitle: "Ubah Kelurahan",
                    breadcrumbs: ["Master", "Provinsi", "Kota / Kabupaten", "Kecamatan", "Kelurahan", "Ubah"],
                    permission: "master-provinsi-update",
                },
            },
            //-------jadwal-test-----------
            {
                path: "/master/jadwal-test",
                name: "master-jadwal-test",
                component: () => import("@/views/master/jadwal-test/index.vue"),
                meta: {
                    pageTitle: "Master Jadwal Test",
                    breadcrumbs: ["Master", "Jadwal Test"],
                    permission: "master-jadwal-test-view",
                },
            },
            {
                path: "/master/jadwal-test/create",
                name: "master-jadwal-test-create",
                component: () => import("@/views/master/jadwal-test/form.vue"),
                meta: {
                    pageTitle: "Create Master Jadwal Test",
                    breadcrumbs: ["master", "Jadwal Test", "Create"],
                    permission: "master-jadwal-test-create",
                },
            },
            {
                path: "/master/jadwal-test/:id",
                name: "master-jadwal-test-edit",
                component: () => import("@/views/master/jadwal-test/form.vue"),
                meta: {
                    pageTitle: "Edit Master Jadwal Test",
                    breadcrumbs: ["Master", "Jadwal Test", "Edit"],
                    permission: "master-jadwal-test-update",
                },
            },
            //-------cicilan-----------
            {
                path: "/master/cicilan",
                name: "master-cicilan",
                component: () => import("@/views/master/cicilan/index.vue"),
                meta: {
                    pageTitle: "Master Cicilan",
                    breadcrumbs: ["Master", "Cicilan"],
                    permission: "master-cicilan-view",
                },
            },
            {
                path: "/master/cicilan/create",
                name: "master-cicilan-create",
                component: () => import("@/views/master/cicilan/form.vue"),
                meta: {
                    pageTitle: "Create Master Cicilan",
                    breadcrumbs: ["master", "Cicilan", "Create"],
                    permission: "master-cicilan-create",
                },
            },
            {
                path: "/master/cicilan/:id",
                name: "master-cicilan-edit",
                component: () => import("@/views/master/cicilan/form.vue"),
                meta: {
                    pageTitle: "Edit Master Cicilan",
                    breadcrumbs: ["Master", "Cicilan", "Edit"],
                    permission: "master-cicilan-update",
                },
            },
            //-------periode-----------
            {
                path: "/master/periode",
                name: "master-periode",
                component: () => import("@/views/master/periode/index.vue"),
                meta: {
                    pageTitle: "Master Periode",
                    breadcrumbs: ["Master", "Periode"],
                    permission: "master-periode-view",
                },
            },
            {
                path: "/master/periode/create",
                name: "master-periode-create",
                component: () => import("@/views/master/periode/form.vue"),
                meta: {
                    pageTitle: "Create Master Periode",
                    breadcrumbs: ["master", "Periode", "Create"],
                    permission: "master-periode-create",
                },
            },
            {
                path: "/master/periode/:id",
                name: "master-periode-edit",
                component: () => import("@/views/master/periode/form.vue"),
                meta: {
                    pageTitle: "Edit Master Periode",
                    breadcrumbs: ["Master", "Periode", "Edit"],
                    permission: "master-periode-update",
                },
            },
            //-------cutoff pembayaran apoteker-----------
            {
                path: "/master/cutoff-pembayaran-apoteker",
                name: "master-cutoff-pembayaran-apoteker",
                component: () =>
                    import(
                        "@/views/master/cutoff-pembayaran-apoteker/index.vue"
                    ),
                meta: {
                    pageTitle: "Master Cutoff Pembayaran Apoteker",
                    breadcrumbs: ["Master", "Cutoff Pembayaran Apoteker"],
                    permission: "master-cutoff-pembayaran-apoteker-view",
                },
            },
            {
                path: "/master/cutoff-pembayaran-apoteker/create",
                name: "master-cutoff-pembayaran-apoteker-create",
                component: () =>
                    import(
                        "@/views/master/cutoff-pembayaran-apoteker/form.vue"
                    ),
                meta: {
                    pageTitle: "Create Master Cutoff Pembayaran Apoteker",
                    breadcrumbs: ["master", "Cutoff Pembayaran Apoteker", "Create"],
                    permission: "master-cutoff-pembayaran-apoteker-create",
                },
            },
            {
                path: "/master/cutoff-pembayaran-apoteker/:id",
                name: "master-cutoff-pembayaran-apoteker-edit",
                component: () =>
                    import(
                        "@/views/master/cutoff-pembayaran-apoteker/form.vue"
                    ),
                meta: {
                    pageTitle: "Edit Master Cutoff Pembayaran Apoteker",
                    breadcrumbs: ["Master", "Cutoff Pembayaran Apoteker", "Edit"],
                    permission: "master-cutoff-pembayaran-apoteker-update",
                },
            },
            //-------agama-----------
            {
                path: "/master/agama",
                name: "master-agama",
                component: () => import("@/views/master/agama/index.vue"),
                meta: {
                    pageTitle: "Master Agama",
                    breadcrumbs: ["Master", "Agama"],
                    permission: "master-agama-view",
                },
            },
            {
                path: "/master/agama/create",
                name: "master-agama-create",
                component: () => import("@/views/master/agama/form.vue"),
                meta: {
                    pageTitle: "Create Master Agama",
                    breadcrumbs: ["master", "Agama", "Create"],
                    permission: "master-agama-create",
                },
            },
            {
                path: "/master/agama/:id",
                name: "master-agama-edit",
                component: () => import("@/views/master/agama/form.vue"),
                meta: {
                    pageTitle: "Edit Master Agama",
                    breadcrumbs: ["Master", "Agama", "Edit"],
                    permission: "master-agama-update",
                },
            },
            //-------suku-----------
            {
                path: "/master/suku",
                name: "master-suku",
                component: () => import("@/views/master/suku/index.vue"),
                meta: {
                    pageTitle: "Master Suku",
                    breadcrumbs: ["Master", "Suku"],
                    permission: "master-suku-view",
                },
            },
            {
                path: "/master/suku/create",
                name: "master-suku-create",
                component: () => import("@/views/master/suku/form.vue"),
                meta: {
                    pageTitle: "Create Master Suku",
                    breadcrumbs: ["master", "Suku", "Create"],
                    permission: "master-suku-create",
                },
            },
            {
                path: "/master/suku/:id",
                name: "master-suku-edit",
                component: () => import("@/views/master/suku/form.vue"),
                meta: {
                    pageTitle: "Edit Master Suku",
                    breadcrumbs: ["Master", "Suku", "Edit"],
                    permission: "master-suku-update",
                },
            },
            //-------rincian dana-----------
            {
                path: "/master/rincian-dana",
                name: "master-rincian-dana",
                component: () =>
                    import("@/views/master/rincian-dana/index.vue"),
                meta: {
                    pageTitle: "Master Rincian Dana",
                    breadcrumbs: ["Master", "Rincian Dana"],
                    permission: "master-rincian-dana-view",
                },
            },
            {
                path: "/master/rincian-dana/create",
                name: "master-rincian-dana-create",
                component: () => import("@/views/master/rincian-dana/form.vue"),
                meta: {
                    pageTitle: "Create Master Rincian Dana",
                    breadcrumbs: ["master", "Rincian Dana", "Create"],
                    permission: "master-rincian-dana-create",
                },
            },
            {
                path: "/master/rincian-dana/:id",
                name: "master-rincian-dana-edit",
                component: () => import("@/views/master/rincian-dana/form.vue"),
                meta: {
                    pageTitle: "Edit Master Rincian Dana",
                    breadcrumbs: ["Master", "Rincian Dana", "Edit"],
                    permission: "master-rincian-dana-update",
                },
            },
            //-------sumbangan-----------
            {
                path: "/master/sumbangan",
                name: "master-sumbangan",
                component: () => import("@/views/master/sumbangan/index.vue"),
                meta: {
                    pageTitle: "Master Sumbangan",
                    breadcrumbs: ["Master", "Sumbangan"],
                    permission: "master-sumbangan-view",
                },
            },
            {
                path: "/master/sumbangan/create",
                name: "master-sumbangan-create",
                component: () => import("@/views/master/sumbangan/form.vue"),
                meta: {
                    pageTitle: "Create Master Sumbangan",
                    breadcrumbs: ["master", "Sumbangan", "Create"],
                    permission: "master-sumbangan-create",
                },
            },
            {
                path: "/master/sumbangan/:id",
                name: "master-sumbangan-edit",
                component: () => import("@/views/master/sumbangan/form.vue"),
                meta: {
                    pageTitle: "Edit Master Sumbangan",
                    breadcrumbs: ["Master", "Sumbangan", "Edit"],
                    permission: "master-sumbangan-update",
                },
            },
            //-------diskon-----------
            {
                path: "/master/diskon",
                name: "master-diskon",
                component: () => import("@/views/master/diskon/index.vue"),
                meta: {
                    pageTitle: "Master Diskon",
                    breadcrumbs: ["Master", "Diskon"],
                    permission: "master-diskon-view",
                },
            },
            {
                path: "/master/diskon/create",
                name: "master-diskon-create",
                component: () => import("@/views/master/diskon/form.vue"),
                meta: {
                    pageTitle: "Create Master Diskon",
                    breadcrumbs: ["master", "Diskon", "Create"],
                    permission: "master-diskon-create",
                },
            },
            {
                path: "/master/diskon/:id",
                name: "master-diskon-edit",
                component: () => import("@/views/master/diskon/form.vue"),
                meta: {
                    pageTitle: "Edit Master Diskon",
                    breadcrumbs: ["Master", "Diskon", "Edit"],
                    permission: "master-diskon-update",
                },
            },
            //-------afiliator-----------
            {
                path: "/master/afiliator",
                name: "master-afiliator",
                component: () => import("@/views/master/afiliator/index.vue"),
                meta: {
                    pageTitle: "Master Afiliator",
                    breadcrumbs: ["Master", "Afiliator"],
                    permission: "master-afiliator-view",
                },
            },
            {
                path: "/master/afiliator/create",
                name: "master-afiliator-create",
                component: () => import("@/views/master/afiliator/form.vue"),
                meta: {
                    pageTitle: "Create Master Afiliator",
                    breadcrumbs: ["master", "Afiliator", "Create"],
                    permission: "master-afiliator-create",
                },
            },
            {
                path: "/master/afiliator/:id",
                name: "master-afiliator-edit",
                component: () => import("@/views/master/afiliator/form.vue"),
                meta: {
                    pageTitle: "Edit Master Afiliator",
                    breadcrumbs: ["Master", "Afiliator", "Edit"],
                    permission: "master-afiliator-update",
                },
            },
            //-------biaya-pendaftaran-----------
            {
                path: "/master/biaya-pendaftaran",
                name: "master-biaya-pendaftaran",
                component: () => import("@/views/master/biaya-pendaftaran/index.vue"),
                meta: {
                    pageTitle: "Master Biaya Pendaftaran",
                    breadcrumbs: ["Master", "biaya-pendaftaran"],
                    permission: "master-biaya-pendaftaran-view",
                },
            },
            {
                path: "/master/biaya-pendaftaran/create",
                name: "master-biaya-pendaftaran-create",
                component: () => import("@/views/master/biaya-pendaftaran/form.vue"),
                meta: {
                    pageTitle: "Create Master Biaya Pendaftaran",
                    breadcrumbs: ["master", "biaya-pendaftaran", "Create"],
                    permission: "master-biaya-pendaftaran-create",
                },
            },
            {
                path: "/master/biaya-pendaftaran/:id",
                name: "master-biaya-pendaftaran-edit",
                component: () => import("@/views/master/biaya-pendaftaran/form.vue"),
                meta: {
                    pageTitle: "Edit Master Biaya Pendaftaran",
                    breadcrumbs: ["Master", "biaya-pendaftaran", "Edit"],
                    permission: "master-biaya-pendaftaran-update",
                },
            },
            //-------sma-----------
            {
                path: "/master/sma",
                name: "master-sma",
                component: () => import("@/views/master/sma/index.vue"),
                meta: {
                    pageTitle: "Master SMA",
                    breadcrumbs: ["Master", "SMA"],
                    permission: "master-sma-view",
                },
            },
            {
                path: "/master/sma/create",
                name: "master-sma-create",
                component: () => import("@/views/master/sma/form.vue"),
                meta: {
                    pageTitle: "Create Master SMA",
                    breadcrumbs: ["Master", "SMA", "Create"],
                    permission: "master-sma-create",
                },
            },
            {
                path: "/master/sma/:id",
                name: "master-sma-edit",
                component: () => import("@/views/master/sma/form.vue"),
                meta: {
                    pageTitle: "Edit Master SMA",
                    breadcrumbs: ["Master", "SMA", "Edit"],
                    permission: "master-sma-update",
                },
            },
            {
                path: "/master/sma/view/:id",
                name: "master-sma-view",
                component: () => import("@/views/master/sma/view.vue"),
                meta: {
                    pageTitle: "View Master SMA",
                    breadcrumbs: ["Master", "SMA", "View"],
                    permission: "master-sma-view",
                },
            },
            {
                path: "/master/sma/:id/create",
                name: "create-jurusan-sma",
                component: () => import("@/views/master/sma/jurusan/form.vue"),
                meta: {
                    pageTitle: "Tambah Jurusan SMA",
                    breadcrumbs: ["Jurusan", "SMA", "Create"],
                    permission: "master-sma-jurusan-create",
                },
            },
            {
                path: "/master/sma/:id/edit/:idJurusan",
                name: "edit-jurusan-sma",
                component: () => import("@/views/master/sma/jurusan/form.vue"),
                meta: {
                    pageTitle: "Edit Jurusan SMA",
                    breadcrumbs: ["Jurusan", "SMA", "Edit"],
                    permission: "master-sma-jurusan-edit",
                },
            },
            //-------sma-nama-----------
            {
                path: "/master/sma-nama",
                name: "master-sma-nama",
                component: () => import("@/views/master/sma-nama/index.vue"),
                meta: {
                    pageTitle: "Master sma-nama",
                    breadcrumbs: ["Master", "sma-nama"],
                    permission: "master-sma-nama-view",
                },
            },
            {
                path: "/master/sma-nama/create",
                name: "master-sma-nama-create",
                component: () => import("@/views/master/sma-nama/form.vue"),
                meta: {
                    pageTitle: "Create Master sma-nama",
                    breadcrumbs: ["master", "sma-nama", "Create"],
                    permission: "master-sma-nama-create",
                },
            },
            {
                path: "/master/sma-nama/:id",
                name: "master-sma-nama-edit",
                component: () => import("@/views/master/sma-nama/form.vue"),
                meta: {
                    pageTitle: "Edit Master sma-nama",
                    breadcrumbs: ["Master", "sma-nama", "Edit"],
                    permission: "master-sma-nama-update",
                },
            },
            //-------sma-mou-----------
            {
                path: "/master/sma-mou",
                name: "master-sma-mou",
                component: () => import("@/views/master/sma-mou/index.vue"),
                meta: {
                    pageTitle: "Master Sma Mou",
                    breadcrumbs: ["Master", "sma-mou"],
                    permission: "master-sma-mou-view",
                },
            },
            {
                path: "/master/sma-mou/create",
                name: "master-sma-mou-create",
                component: () => import("@/views/master/sma-mou/form.vue"),
                meta: {
                    pageTitle: "Create Master Sma Mou",
                    breadcrumbs: ["master", "sma-mou", "Create"],
                    permission: "master-sma-mou-create",
                },
            },
            {
                path: "/master/sma-mou/:id",
                name: "master-sma-mou-edit",
                component: () => import("@/views/master/sma-mou/form.vue"),
                meta: {
                    pageTitle: "Edit Master Sma Mou",
                    breadcrumbs: ["Master", "sma-mou", "Edit"],
                    permission: "master-sma-nama-update",
                },
            },
            //-------notifikasi-----------
            {
                path: "/master/notifikasi-whatsapp",
                name: "master-notifikasi-whatsapp",
                component: () => import("@/views/master/notifikasi-whatsapp/index.vue"),
                meta: {
                    pageTitle: "Master Notifikasi Whatsapp",
                    breadcrumbs: ["Master", "Notifikasi Whatsapp"],
                    permission: "master-notifikasi-whatsapp-view",
                },
            },
            {
                path: "/master/notifikasi-whatsapp/create",
                name: "master-notifikasi-whatsapp-create",
                component: () => import("@/views/master/notifikasi-whatsapp/form.vue"),
                meta: {
                    pageTitle: "Create Master Notifikasi Whatsapp",
                    breadcrumbs: ["master", "Notifikasi Whatsapp", "Create"],
                    permission: "master-notifikasi-whatsapp-create",
                },
            },
            {
                path: "/master/notifikasi-whatsapp/:id",
                name: "master-notifikasi-whatsapp-edit",
                component: () => import("@/views/master/notifikasi-whatsapp/form.vue"),
                meta: {
                    pageTitle: "Edit Master Notifikasi Whatsapp",
                    breadcrumbs: ["Master", "Notifikasi Whatsapp", "Edit"],
                    permission: "master-notifikasi-whatsapp-update",
                },
            },
            //-------list test-----------
            {
                path: "/master/list-test",
                name: "master-list-test",
                component: () => import("@/views/master/list-test/index.vue"),
                meta: {
                    pageTitle: "Master List Test",
                    breadcrumbs: ["Master", "List Test"],
                    permission: "master-list-test-view",
                },
            },
            {
                path: "/master/list-test/create",
                name: "master-list-test-create",
                component: () => import("@/views/master/list-test/form.vue"),
                meta: {
                    pageTitle: "Create Master List Test",
                    breadcrumbs: ["master", "List Test", "Create"],
                    permission: "master-list-test-create",
                },
            },
            {
                path: "/master/list-test/:id",
                name: "master-list-test-edit",
                component: () => import("@/views/master/list-test/form.vue"),
                meta: {
                    pageTitle: "Edit Master List Test",
                    breadcrumbs: ["Master", "List Test", "Edit"],
                    permission: "master-list-test-update",
                },
            },
            //-------skema-pembayaran-----------
            {
                path: "/master/skema-pembayaran",
                name: "master-skema-pembayaran",
                component: () => import("@/views/master/skema-pembayaran/index.vue"),
                meta: {
                    pageTitle: "Master Skema Pembayaran",
                    breadcrumbs: ["Master", "Skema Pembayaran"],
                    permission: "master-skema-pembayaran-view",
                },
            },
            {
                path: "/master/skema-pembayaran/create",
                name: "master-skema-pembayaran-create",
                component: () => import("@/views/master/skema-pembayaran/form.vue"),
                meta: {
                    pageTitle: "Create Skema Pembayaran",
                    breadcrumbs: ["Master", "Skema Pembayaran", "Create"],
                    permission: "master-skema-pembayaran-create",
                },
            },
            {
                path: "/master/skema-pembayaran/:id",
                name: "master-skema-pembayaran-edit",
                component: () => import("@/views/master/skema-pembayaran/form.vue"),
                meta: {
                    pageTitle: "Edit Skema Pembayaran",
                    breadcrumbs: ["Master", "Skema Pembayaran", "Edit"],
                    permission: "master-skema-pembayaran-update",
                },
            },
            //-------berkas mahasiswa-----------
            {
                path: "/berkas-mahasiswa",
                name: "berkas-mahasiswa",
                component: () =>
                    import("@/views/berkas-mahasiswa/index.vue"),
                meta: {
                    pageTitle: "Berkas Mahasiswa",
                    breadcrumbs: ["Berkas Mahasiswa"],
                    permission: "berkas-mahasiswa-view",
                },
            },
            {
                path: "/berkas-mahasiswa/:id",
                name: "berkas-mahasiswa-edit",
                component: () =>
                    import("@/views/berkas-mahasiswa/form.vue"),
                meta: {
                    pageTitle: "Edit Berkas Mahasiswa",
                    breadcrumbs: ["Berkas Mahasiswa", "Edit"],
                    permission: "berkas-mahasiswa-update",
                },
            },
            //-------sim mahasiswa-----------
            {
                path: "/sim-mahasiswa",
                name: "sim-mahasiswa",
                component: () =>
                    import("@/views/sim-mahasiswa/index.vue"),
                meta: {
                    pageTitle: "Sim Mahasiswa",
                    breadcrumbs: ["Sim Mahasiswa"],
                    permission: "sim-mahasiswa-view",
                },
            },
            {
                path: "/sim-mahasiswa/:id",
                name: "sim-mahasiswa-view",
                component: () =>
                    import("@/views/sim-mahasiswa/form.vue"),
                meta: {
                    pageTitle: "View Sim Mahasiswa",
                    breadcrumbs: ["Sim Mahasiswa", "View"],
                    permission: "sim-mahasiswa-update",
                },
            },
            //-------Download Foto Mahasiswa-----------
            {
                path: "/download-foto-mahasiswa",
                name: "download-foto-mahasiswa",
                component: () =>
                    import("@/views/download-foto-mahasiswa/index.vue"),
                meta: {
                    pageTitle: "Download File Mahasiswa",
                    breadcrumbs: ["Download File Mahasiswa"],
                    permission: "download-foto-mahasiswa",
                },
            },
            //-------generate-npm-----------
            {
                path: "/npm-mahasiswa",
                name: "npm-mahasiswa",
                component: () => import("@/views/npm-mahasiswa/index.vue"),
                meta: {
                    pageTitle: "NPM Mahasiswa",
                    breadcrumbs: ["NPM Mahasiswa"],
                    permission: "npm-mahasiswa-view",
                },
            },
            {
                path: "/npm-mahasiswa/:id",
                name: "npm-mahasiswa-view",
                component: () => import("@/views/npm-mahasiswa/form.vue"),
                meta: {
                    pageTitle: "View NPM Mahasiswa",
                    breadcrumbs: ["NPM Mahasiswa", "View"],
                    permission: "npm-mahasiswa-update",
                },
            },
            //-------jaket-mahasiswa-----------
            {
                path: "/jaket-mahasiswa",
                name: "jaket-mahasiswa",
                component: () => import("@/views/jaket-mahasiswa/index.vue"),
                meta: {
                    pageTitle: "List Jaket Mahasiswa",
                    breadcrumbs: ["List", "jaket-mahasiswa"],
                    permission: "jaket-mahasiswa-view",
                },
            },
            {
                path: "/jaket-mahasiswa/create",
                name: "jaket-mahasiswa-create",
                component: () => import("@/views/jaket-mahasiswa/form.vue"),
                meta: {
                    pageTitle: "Create  Jaket Mahasiswa",
                    breadcrumbs: ["Jaket Mahasiswa", "Create"],
                    permission: "jaket-mahasiswa-create",
                },
            },
            {
                path: "/jaket-mahasiswa/:id",
                name: "jaket-mahasiswa-edit",
                component: () => import("@/views/jaket-mahasiswa/form.vue"),
                meta: {
                    pageTitle: "Edit Jaket Mahasiswa",
                    breadcrumbs: ["Jaket Mahasiswa", "Edit"],
                    permission: "jaket-mahasiswa-update",
                },
            },
            //-------event-afiliator-----------
            {
                path: "/event-afiliator",
                name: "event-afiliator",
                component: () => import("@/views/event-afiliator/index.vue"),
                meta: {
                    pageTitle: "Event Afiliator",
                    breadcrumbs: ["Event", "Afiliator"],
                    permission: "event-afiliator-view",
                },
            },
            {
                path: "/event-afiliator/create",
                name: "event-afiliator-create",
                component: () => import("@/views/event-afiliator/form.vue"),
                meta: {
                    pageTitle: "Create Event Afiliator",
                    breadcrumbs: ["Event", "Afiliator", "Create"],
                    permission: "event-afiliator-create",
                },
            },
            {
                path: "/event-afiliator/:id",
                name: "event-afiliator-edit",
                component: () => import("@/views/event-afiliator/form.vue"),
                meta: {
                    pageTitle: "Edit Event Afiliator",
                    breadcrumbs: ["Event", "Afiliator", "Edit"],
                    permission: "event-afiliator-update",
                },
            },
            {
                path: "/event-afiliator/view/:id",
                name: "event-afiliator-view",
                component: () => import("@/views/event-afiliator/view.vue"),
                meta: {
                    pageTitle: "View Event Afiliator",
                    breadcrumbs: ["Event", "Afiliator", "View"],
                    permission: "event-afiliator-view",
                },
            },
            //-------referral-code-----------
            {
                path: "/referral-code",
                name: "referral-code",
                component: () => import("@/views/referral-code/index.vue"),
                meta: {
                    pageTitle: "Referral Code",
                    breadcrumbs: ["Referral Code"],
                    permission: "referral-code-view",
                },
            },
            //---- Marketing
            {
                path: "/marketing",
                children: [
                    {
                        path: "data-survey-siswa",
                        name: "marketing-data-survey-siswa",
                        component: () => import("@/views/marketing/data-survey-siswa/index.vue"),
                        meta: {
                            pageTitle: "Marketing Data Survey Siswa",
                            breadcrumbs: ["Marketing", "Data Survey Siswa"],
                            permission: "marketing-data-survey-siswa",
                        },
                    },
                    {
                        path: "data-survey-siswa/create",
                        name: "marketing-data-survey-siswa-create",
                        component: () => import("@/views/marketing/data-survey-siswa/form.vue"),
                        meta: {
                            pageTitle: "Create Marketing Data Survey Siswa",
                            breadcrumbs: ["Marketing", "Data Survey Siswa", "Create"],
                            permission: "marketing-data-survey-siswa-create",
                        },
                    },
                    {
                        path: "data-survey-siswa/view/:id",
                        name: "marketing-data-survey-siswa-view",
                        component: () => import("@/views/marketing/data-survey-siswa/view.vue"),
                        meta: {
                            pageTitle: "View Marketing Data Survey Siswa",
                            breadcrumbs: ["Marketing", "Data Survey Siswa", "View"],
                            permission: "marketing-data-survey-siswa-view",
                        },
                    },
                    //-------kirim informasi-----------
                    {
                        path: "kirim-informasi",
                        name: "marketing-kirim-informasi",
                        component: () => import("@/views/marketing/kirim-informasi/index.vue"),
                        meta: {
                            pageTitle: "Marketing Kirim Informasi",
                            breadcrumbs: ["Marketing", "Kirim Informasi"],
                            permission: "marketing-kirim-informasi-view",
                        },
                    },
                ]
            },
            //-------Pendaftaran-Apoteker-----------
            {
                path: "/jadwal-test",
                name: "jadwal-test",
                component: () =>
                    import("@/views/jadwal-test/index.vue"),
                meta: {
                    pageTitle: "Jadwal Test",
                    breadcrumbs: ["Jadwal Test"],
                    permission: "jadwal-test-view",
                },
            },
            {
                path: "/jadwal-test/create",
                name: "jadwal-test-create",
                component: () =>
                    import("@/views/jadwal-test/form.vue"),
                meta: {
                    pageTitle: "Create Jadwal Test",
                    breadcrumbs: ["Jadwal Test", "Create"],
                    permission: "jadwal-test-create",
                },
            },
            {
                path: "/jadwal-test/:id",
                name: "jadwal-test-edit",
                component: () =>
                    import("@/views/jadwal-test/form.vue"),
                meta: {
                    pageTitle: "Edit Jadwal Test",
                    breadcrumbs: ["Jadwal Test", "Edit"],
                    permission: "jadwal-test-update",
                },
            },
            //-------pembayaran-mahasiswa-----------
            {
                path: "/pembayaran-mahasiswa",
                name: "pembayaran-mahasiswa",
                component: () =>
                    import("@/views/pembayaran-mahasiswa/index.vue"),
                meta: {
                    pageTitle: "Pembayaran Mahasiswa",
                    breadcrumbs: ["Pembayaran Mahasiswa"],
                    permission: "pembayaran-mahasiswa-view",
                },
            },
            {
                path: "/pembayaran-mahasiswa/create",
                name: "pembayaran-mahasiswa-create",
                component: () =>
                    import("@/views/pembayaran-mahasiswa/form.vue"),
                meta: {
                    pageTitle: "Create Pembayaran Mahasiswa",
                    breadcrumbs: ["Pembayaran Mahasiswa", "Create"],
                    permission: "pembayaran-mahasiswa-create",
                },
            },
            {
                path: "/pembayaran-mahasiswa/:id",
                name: "pembayaran-mahasiswa-edit",
                component: () =>
                    import("@/views/pembayaran-mahasiswa/form.vue"),
                meta: {
                    pageTitle: "Edit Pembayaran Mahasiswa",
                    breadcrumbs: ["Pembayaran Mahasiswa", "Edit"],
                    permission: "pembayaran-mahasiswa-update",
                },
            },
            //-------transaksi-va-----------
            {
                path: "/transaksi-va",
                name: "transaksi-va",
                component: () =>
                    import("@/views/transaksi-va/index.vue"),
                meta: {
                    pageTitle: "Transaksi Virtual Account",
                    breadcrumbs: ["Transaksi Virtual Account"],
                    permission: "transaksi-va-view",
                },
            },
            {
                path: "/transaksi-va/create",
                name: "transaksi-va-create",
                component: () =>
                    import("@/views/transaksi-va/form.vue"),
                meta: {
                    pageTitle: "Create Transaksi Virtual Account",
                    breadcrumbs: ["Transaksi Virtual Account", "Create"],
                    permission: "transaksi-va-create",
                },
            },
            {
                path: "/transaksi-va/:id",
                name: "transaksi-va-edit",
                component: () =>
                    import("@/views/transaksi-va/form.vue"),
                meta: {
                    pageTitle: "Edit Transaksi Virtual Account",
                    breadcrumbs: ["Transaksi Virtual Account", "Edit"],
                    permission: "transaksi-va-update",
                },
            },
            //-----Laporan-------------
            {
                path: "/laporan",
                children: [
                    {
                        path: "pendaftaran-prodi",
                        name: "laporan-pendaftaran-prodi",
                        component: () =>
                            import(
                                "@/views/laporan/pendaftaran-prodi/index.vue"
                            ),
                        meta: {
                            pageTitle: "Laporan Pendaftaran per Prodi",
                            breadcrumbs: ["Laporan", "Pendaftaran", "Prodi"],
                            permission: "laporan-pendaftaran-prodi",
                        },
                    },
                    {
                        path: "total-pendaftaran",
                        name: "laporan-total-pendaftaran",
                        component: () =>
                            import(
                                "@/views/laporan/total-pendaftaran/index.vue"
                            ),
                        meta: {
                            pageTitle: "Laporan Total Pendaftaran",
                            breadcrumbs: ["Laporan", "Total", "Pendaftaran"],
                            permission: "laporan-total-pendaftaran",
                        },
                    },
                    {
                        path: "per-tahun-akademik",
                        name: "laporan-per-tahun-akademik",
                        component: () =>
                            import(
                                "@/views/laporan/per-tahun-akademik/index.vue"
                            ),
                        meta: {
                            pageTitle: "Laporan Per Tahun Akademik",
                            breadcrumbs: ["Laporan", "Per Tahun Akademik"],
                            permission: "laporan-per-tahun-akademik",
                        },
                    },
                    {
                        path: "ukuran-almamater",
                        name: "laporan-ukuran-almamater",
                        component: () =>
                            import(
                                "@/views/laporan/ukuran-almamater/index.vue"
                            ),
                        meta: {
                            pageTitle: "Laporan Ukuran Almamater",
                            breadcrumbs: ["Laporan", "Ukuran Almamater"],
                            permission: "laporan-ukuran-almamater",
                        },
                    },
                    {
                        path: "kuesioner-mahasiswa",
                        name: "laporan-kuesioner-mahasiswa",
                        component: () =>
                            import(
                                "@/views/laporan/kuesioner-mahasiswa/index.vue"
                            ),
                        meta: {
                            pageTitle: "Laporan Kuesioner Mahasiswa",
                            breadcrumbs: ["Laporan", "Kuesioner Mahasiswa"],
                            permission: "laporan-kuesioner-mahasiswa",
                        },
                    },
                    {
                        path: "berdasarkan-suku",
                        name: "laporan-berdasarkan-suku",
                        component: () =>
                            import(
                                "@/views/laporan/berdasarkan-suku/index.vue"
                            ),
                        meta: {
                            pageTitle: "Laporan Berdasarkan Suku",
                            breadcrumbs: ["Laporan", "Berdasarkan Suku"],
                            permission: "laporan-berdasarkan-suku",
                        },
                    },
                    {
                        path: "wilayah-asal-sekolah",
                        name: "laporan-wilayah-asal-sekolah",
                        component: () =>
                            import(
                                "@/views/laporan/wilayah-asal-sekolah/index.vue"
                            ),
                        meta: {
                            pageTitle: "Laporan Wilayah Asal Sekolah",
                            breadcrumbs: ["Laporan", "Wilayah Asal Sekolah"],
                            permission: "laporan-wilayah-asal-sekolah",
                        },
                    },
                    {
                        path: "camaba-cbt",
                        name: "laporan-camaba-cbt",
                        component: () =>
                            import("@/views/laporan/camaba-cbt/index.vue"),
                        meta: {
                            pageTitle: "Laporan Camaba CBT",
                            breadcrumbs: ["Laporan", "Camaba CBT"],
                            permission: "laporan-camaba-cbt",
                        },
                    },
                    {
                        path: "camaba",
                        name: "laporan-camaba",
                        component: () =>
                            import("@/views/laporan/camaba/index.vue"),
                        meta: {
                            pageTitle: "Laporan Camaba",
                            breadcrumbs: ["Laporan", "Camaba"],
                            permission: "laporan-camaba",
                        },
                    },
                    {
                        path: "camaba-mundur",
                        name: "laporan-camaba-mundur",
                        component: () =>
                            import("@/views/laporan/camaba-mundur/index.vue"),
                        meta: {
                            pageTitle: "Laporan Camaba Mundur",
                            breadcrumbs: ["Laporan", "Camaba Mundur"],
                            permission: "laporan-camaba-mundur",
                        },
                    },
                    {
                        path: "hasil-kelulusan",
                        name: "laporan-hasil-kelulusan",
                        component: () =>
                            import("@/views/laporan/hasil-kelulusan/index.vue"),
                        meta: {
                            pageTitle: "Laporan Hasil Kelulusan",
                            breadcrumbs: ["Laporan", "Hasil Kelulusan"],
                            permission: "laporan-hasil-kelulusan",
                        },
                    },
                    {
                        path: "hasil-cbt",
                        name: "laporan-hasil-cbt",
                        component: () =>
                            import("@/views/laporan/hasil-cbt/index.vue"),
                        meta: {
                            pageTitle: "Laporan Hasil CBT",
                            breadcrumbs: ["Laporan", "Hasil CBT"],
                            permission: "laporan-hasil-cbt",
                        },
                    },
                    {
                        path: "pembayaran-mahasiswa",
                        name: "laporan-pembayaran-mahasiswa",
                        component: () =>
                            import("@/views/laporan/pembayaran-mahasiswa/index.vue"),
                        meta: {
                            pageTitle: "Laporan Pembayaran Mahasiswa",
                            breadcrumbs: ["Laporan", "Pembayaran Mahasiswa"],
                            permission: "laporan-pembayaran-mahasiswa",
                        },
                    },
                    {
                        path: "status-pendaftaran",
                        name: "laporan-status-pendaftaran",
                        component: () =>
                            import("@/views/laporan/status-pendaftaran/index.vue"),
                        meta: {
                            pageTitle: "Laporan Status Pendaftaran",
                            breadcrumbs: ["Laporan", "Status Pendaftaran"],
                            permission: "laporan-status-pendaftaran",
                        },
                    },
                    {
                        path: "berkas-sim",
                        name: "laporan-berkas-sim",
                        component: () =>
                            import("@/views/laporan/berkas-sim/index.vue"),
                        meta: {
                            pageTitle: "Laporan Berkas dan SIM",
                            breadcrumbs: ["Laporan", "Berkas dan SIM"],
                            permission: "laporan-berkas-sim",
                        },
                    },
                    {
                        path: "status-berkas-pendaftaran",
                        name: "laporan-status-berkas-pendaftaran",
                        component: () =>
                            import("@/views/laporan/status-berkas-pendaftaran/index.vue"),
                        meta: {
                            pageTitle: "Laporan Status Berkas Pendaftaran",
                            breadcrumbs: ["Laporan", "Status Berkas Pendaftaran"],
                            permission: "laporan-status-berkas-pendaftaran",
                        },
                    },
                    {
                        path: "npm-mahasiswa",
                        name: "laporan-npm-mahasiswa",
                        component: () =>
                            import("@/views/laporan/npm-mahasiswa/index.vue"),
                        meta: {
                            pageTitle: "Laporan NPM Mahasiswa",
                            breadcrumbs: ["Laporan", "NPM Mahasiswa"],
                            permission: "laporan-npm-mahasiswa",
                        },
                    },
                    {
                        path: "mahasiswa-feeder",
                        name: "laporan-mahasiswa-feeder",
                        component: () =>
                            import("@/views/laporan/mahasiswa-feeder/index.vue"),
                        meta: {
                            pageTitle: "Laporan Mahasiswa Feeder",
                            breadcrumbs: ["Laporan", "Mahasiswa Feeder"],
                            permission: "laporan-mahasiswa-feeder",
                        },
                    },
                    {
                        path: "mahasiswa-fix-bayar",
                        name: "laporan-mahasiswa-fix-bayar",
                        component: () =>
                            import("@/views/laporan/mahasiswa-fix-bayar/index.vue"),
                        meta: {
                            pageTitle: "Laporan Mahasiswa Fix Bayar",
                            breadcrumbs: ["Laporan", "Mahasiswa Fix Bayar"],
                            permission: "laporan-mahasiswa-fix-bayar",
                        },
                    },
                    {
                        path: "asal-sekolah-fix-bayar",
                        name: "laporan-asal-sekolah-fix-bayar",
                        component: () =>
                            import("@/views/laporan/asal-sekolah-fix-bayar/index.vue"),
                        meta: {
                            pageTitle: "Laporan Asal Sekolah Fix Bayar",
                            breadcrumbs: ["Laporan", "Asal Sekolah Fix Bayar"],
                            permission: "laporan-asal-sekolah-fix-bayar",
                        },
                    },
                    {
                        path: "pendapatan-prodi",
                        name: "laporan-pendapatan-prodi",
                        component: () =>
                            import("@/views/laporan/pendapatan-prodi/index.vue"),
                        meta: {
                            pageTitle: "Laporan Pendapatan Prodi",
                            breadcrumbs: ["Laporan", "Pendapatan Prodi"],
                            permission: "laporan-pendapatan-prodi",
                        },
                    },
                    {
                        path: "pendapatan-detail-prodi",
                        name: "laporan-pendapatan-detail-prodi",
                        component: () =>
                            import("@/views/laporan/pendapatan-detail-prodi/index.vue"),
                        meta: {
                            pageTitle: "Laporan Pendapatan Detail Prodi",
                            breadcrumbs: ["Laporan", "Pendapatan Detail Prodi"],
                            permission: "laporan-pendapatan-detail-prodi",
                        },
                    },
                    {
                        path: "piutang-va",
                        name: "laporan-piutang-va",
                        component: () =>
                            import("@/views/laporan/piutang-va/index.vue"),
                        meta: {
                            pageTitle: "Laporan Piutang VA",
                            breadcrumbs: ["Laporan", "Piutang VA"],
                            permission: "laporan-piutang-va",
                        },
                    },
                    {
                        path: "jumlah-pendaftaran",
                        name: "laporan-jumlah-pendaftaran",
                        component: () =>
                            import("@/views/laporan/jumlah-pendaftaran/index.vue"),
                        meta: {
                            pageTitle: "Laporan Jumlah Pendaftaran",
                            breadcrumbs: ["Laporan", "Jumlah Pendaftaran"],
                            permission: "laporan-jumlah-pendaftaran",
                        },
                    },
                    {
                        path: "voucher-afiliator",
                        name: "laporan-voucher-afiliator",
                        component: () =>
                            import("@/views/laporan/voucher-afiliator/index.vue"),
                        meta: {
                            pageTitle: "Laporan Voucher Afiliator",
                            breadcrumbs: ["Laporan", "Voucher Afiliator"],
                            permission: "laporan-voucher-afiliator",
                        },
                    },
                    {
                        path: "referral-code",
                        name: "laporan-referral-code",
                        component: () =>
                            import("@/views/laporan/referral-code/index.vue"),
                        meta: {
                            pageTitle: "Laporan Referral Code",
                            breadcrumbs: ["Laporan", "Referral Code"],
                            permission: "laporan-referral-code",
                        },
                    },
                ],
            },
            //------------template---------------
            {
                path: "/builder",
                name: "builder",
                component: () => import("@/views/LayoutBuilder.vue"),
                meta: {
                    pageTitle: "Layout Builder",
                    breadcrumbs: ["Layout"],
                },
            },
            {
                path: "/crafted/pages/profile",
                name: "profile",
                component: () =>
                    import("@/components/page-layouts/Profile.vue"),
                meta: {
                    breadcrumbs: ["Pages", "Profile"],
                },
                children: [
                    {
                        path: "overview",
                        name: "profile-overview",
                        component: () =>
                            import(
                                "@/views/crafted/pages/profile/Overview.vue"
                            ),
                        meta: {
                            pageTitle: "Overview",
                        },
                    },
                    {
                        path: "projects",
                        name: "profile-projects",
                        component: () =>
                            import(
                                "@/views/crafted/pages/profile/Projects.vue"
                            ),
                        meta: {
                            pageTitle: "Projects",
                        },
                    },
                    {
                        path: "campaigns",
                        name: "profile-campaigns",
                        component: () =>
                            import(
                                "@/views/crafted/pages/profile/Campaigns.vue"
                            ),
                        meta: {
                            pageTitle: "Campaigns",
                        },
                    },
                    {
                        path: "documents",
                        name: "profile-documents",
                        component: () =>
                            import(
                                "@/views/crafted/pages/profile/Documents.vue"
                            ),
                        meta: {
                            pageTitle: "Documents",
                        },
                    },
                    {
                        path: "connections",
                        name: "profile-connections",
                        component: () =>
                            import(
                                "@/views/crafted/pages/profile/Connections.vue"
                            ),
                        meta: {
                            pageTitle: "Connections",
                        },
                    },
                    {
                        path: "activity",
                        name: "profile-activity",
                        component: () =>
                            import(
                                "@/views/crafted/pages/profile/Activity.vue"
                            ),
                        meta: {
                            pageTitle: "Activity",
                        },
                    },
                ],
            },
            {
                path: "/crafted/pages/wizards/horizontal",
                name: "horizontal-wizard",
                component: () =>
                    import("@/views/crafted/pages/wizards/Horizontal.vue"),
                meta: {
                    pageTitle: "Horizontal",
                    breadcrumbs: ["Pages", "Wizard"],
                },
            },
            {
                path: "/crafted/pages/wizards/vertical",
                name: "vertical-wizard",
                component: () =>
                    import("@/views/crafted/pages/wizards/Vertical.vue"),
                meta: {
                    pageTitle: "Vertical",
                    breadcrumbs: ["Pages", "Wizard"],
                },
            },
            {
                path: "/apps/customers/getting-started",
                name: "apps-customers-getting-started",
                component: () =>
                    import("@/views/apps/customers/GettingStarted.vue"),
                meta: {
                    pageTitle: "Getting Started",
                    breadcrumbs: ["Apps", "Customers"],
                },
            },
            {
                path: "/apps/customers/customers-listing",
                name: "apps-customers-listing",
                component: () =>
                    import("@/views/apps/customers/CustomersListing.vue"),
                meta: {
                    pageTitle: "Customers Listing",
                    breadcrumbs: ["Apps", "Customers"],
                },
            },
            {
                path: "/apps/customers/customer-details",
                name: "apps-customers-details",
                component: () =>
                    import("@/views/apps/customers/CustomerDetails.vue"),
                meta: {
                    pageTitle: "Customers Details",
                    breadcrumbs: ["Apps", "Customers"],
                },
            },
            {
                path: "/apps/subscriptions/getting-started",
                name: "apps-subscriptions-getting-started",
                component: () =>
                    import("@/views/apps/subscriptions/GettingStarted.vue"),
                meta: {
                    pageTitle: "Getting Started",
                    breadcrumbs: ["Apps", "Subscriptions"],
                },
            },
            {
                path: "/apps/subscriptions/subscription-list",
                name: "apps-subscriptions-subscription-list",
                component: () =>
                    import("@/views/apps/subscriptions/SubscriptionList.vue"),
                meta: {
                    pageTitle: "Getting Started",
                    breadcrumbs: ["Apps", "Subscriptions"],
                },
            },
            {
                path: "/apps/subscriptions/add-subscription",
                name: "apps-subscriptions-add-subscription",
                component: () =>
                    import("@/views/apps/subscriptions/AddSubscription.vue"),
                meta: {
                    pageTitle: "Add Subscription",
                    breadcrumbs: ["Apps", "Subscriptions"],
                },
            },
            {
                path: "/apps/subscriptions/view-subscription",
                name: "apps-subscriptions-view-subscription",
                component: () =>
                    import("@/views/apps/subscriptions/ViewSubscription.vue"),
                meta: {
                    pageTitle: "View Subscription",
                    breadcrumbs: ["Apps", "Subscriptions"],
                },
            },
            {
                path: "/apps/calendar",
                name: "apps-calendar",
                component: () => import("@/views/apps/Calendar.vue"),
                meta: {
                    pageTitle: "Calendar",
                    breadcrumbs: ["Apps"],
                },
            },
            {
                path: "/chat/private-chat",
                name: "apps-private-chat",
                component: () => import("@/views/apps/chat/Chat.vue"),
                meta: {
                    pageTitle: "Private Chat",
                    breadcrumbs: ["Apps", "Chat"],
                    permission: "private-chat",
                },
            },
            {
                path: "/apps/chat/group-chat",
                name: "apps-group-chat",
                component: () => import("@/views/apps/chat/Chat.vue"),
                meta: {
                    pageTitle: "Group Chat",
                    breadcrumbs: ["Apps", "Chat"],
                },
            },
            {
                path: "/apps/chat/drawer-chat",
                name: "apps-drawer-chat",
                component: () => import("@/views/apps/chat/DrawerChat.vue"),
                meta: {
                    pageTitle: "Drawer Chat",
                    breadcrumbs: ["Apps", "Chat"],
                },
            },
            {
                path: "/crafted/modals/general/invite-friends",
                name: "modals-general-invite-friends",
                component: () =>
                    import("@/views/crafted/modals/general/InviteFriends.vue"),
                meta: {
                    pageTitle: "Invite Friends",
                    breadcrumbs: ["Crafted", "Modals", "General"],
                },
            },
            {
                path: "/crafted/modals/general/view-user",
                name: "modals-general-view-user",
                component: () =>
                    import("@/views/crafted/modals/general/ViewUsers.vue"),
                meta: {
                    pageTitle: "View User",
                    breadcrumbs: ["Crafted", "Modals", "General"],
                },
            },
            {
                path: "/crafted/modals/general/upgrade-plan",
                name: "modals-general-upgrade-plan",
                component: () =>
                    import("@/views/crafted/modals/general/UpgradePlan.vue"),
                meta: {
                    pageTitle: "Upgrade Plan",
                    breadcrumbs: ["Crafted", "Modals", "General"],
                },
            },
            {
                path: "/crafted/modals/general/share-and-earn",
                name: "modals-general-share-and-earn",
                component: () =>
                    import("@/views/crafted/modals/general/ShareAndEarn.vue"),
                meta: {
                    pageTitle: "Share And Earn",
                    breadcrumbs: ["Crafted", "Modals", "General"],
                },
            },
            {
                path: "/crafted/modals/forms/new-target",
                name: "modals-forms-new-target",
                component: () =>
                    import("@/views/crafted/modals/forms/NewTarget.vue"),
                meta: {
                    pageTitle: "New Target",
                    breadcrumbs: ["Crafted", "Modals", "Forms"],
                },
            },
            {
                path: "/crafted/modals/forms/new-card",
                name: "modals-forms-new-card",
                component: () =>
                    import("@/views/crafted/modals/forms/NewCard.vue"),
                meta: {
                    pageTitle: "New Card",
                    breadcrumbs: ["Crafted", "Modals", "Forms"],
                },
            },
            {
                path: "/crafted/modals/forms/new-address",
                name: "modals-forms-new-address",
                component: () =>
                    import("@/views/crafted/modals/forms/NewAddress.vue"),
                meta: {
                    pageTitle: "New Address",
                    breadcrumbs: ["Crafted", "Modals", "Forms"],
                },
            },
            {
                path: "/crafted/modals/forms/create-api-key",
                name: "modals-forms-create-api-key",
                component: () =>
                    import("@/views/crafted/modals/forms/CreateApiKey.vue"),
                meta: {
                    pageTitle: "Create Api Key",
                    breadcrumbs: ["Crafted", "Modals", "Forms"],
                },
            },
            {
                path: "/crafted/modals/wizards/two-factor-auth",
                name: "modals-wizards-two-factor-auth",
                component: () =>
                    import("@/views/crafted/modals/wizards/TwoFactorAuth.vue"),
                meta: {
                    pageTitle: "Two Factory Auth",
                    breadcrumbs: ["Crafted", "Modals", "Wizards"],
                },
            },
            {
                path: "/crafted/modals/wizards/create-app",
                name: "modals-wizards-create-app",
                component: () =>
                    import("@/views/crafted/modals/wizards/CreateApp.vue"),
                meta: {
                    pageTitle: "Create App",
                    breadcrumbs: ["Crafted", "Modals", "Wizards"],
                },
            },
            {
                path: "/crafted/modals/wizards/create-account",
                name: "modals-wizards-create-account",
                component: () =>
                    import("@/views/crafted/modals/wizards/CreateAccount.vue"),
                meta: {
                    pageTitle: "Create Account",
                    breadcrumbs: ["Crafted", "Modals", "Wizards"],
                },
            },
            {
                path: "/crafted/widgets/lists",
                name: "widgets-list",
                component: () => import("@/views/crafted/widgets/Lists.vue"),
                meta: {
                    pageTitle: "Lists",
                    breadcrumbs: ["Crafted", "Widgets"],
                },
            },
            {
                path: "/crafted/widgets/statistics",
                name: "widgets-statistics",
                component: () =>
                    import("@/views/crafted/widgets/Statistics.vue"),
                meta: {
                    pageTitle: "Statistics",
                    breadcrumbs: ["Crafted", "Widgets"],
                },
            },
            {
                path: "/crafted/widgets/charts",
                name: "widgets-charts",
                component: () => import("@/views/crafted/widgets/Charts.vue"),
                meta: {
                    pageTitle: "Charts",
                    breadcrumbs: ["Crafted", "Widgets"],
                },
            },
            {
                path: "/crafted/widgets/mixed",
                name: "widgets-mixed",
                component: () => import("@/views/crafted/widgets/Mixed.vue"),
                meta: {
                    pageTitle: "Mixed",
                    breadcrumbs: ["Crafted", "Widgets"],
                },
            },
            {
                path: "/crafted/widgets/tables",
                name: "widgets-tables",
                component: () => import("@/views/crafted/widgets/Tables.vue"),
                meta: {
                    pageTitle: "Tables",
                    breadcrumbs: ["Crafted", "Widgets"],
                },
            },
            {
                path: "/crafted/widgets/feeds",
                name: "widgets-feeds",
                component: () => import("@/views/crafted/widgets/Feeds.vue"),
                meta: {
                    pageTitle: "Feeds",
                    breadcrumbs: ["Crafted", "Widgets"],
                },
            },
        ],
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

router.beforeEach((to) => {
    // current page view title
    document.title = `${to.meta.pageTitle} - ${process.env.VUE_APP_NAME}`;

    // reset config to initial state
    store.commit(Mutations.RESET_LAYOUT_CONFIG);
    store.dispatch(Actions.VERIFY_AUTH, { api_token: JwtService.getToken() });
    const account = JwtService.getProfileUser();
    if (account.id) {
        let profile = null;
        ApiService.get("/auth/my-profile").then(({ data }) => {
            if (data.data !== null) {
                profile = data.data;
            }
            if (to.name != "sign-in") {
                if (
                    account.email_verified_at === null &&
                    to.name != "verify-email" &&
                    to.name != "verify-email-proccess"
                ) {
                    router.push({ name: "verify-email" });
                } else if (
                    account.email_verified_at != null &&
                    to.name === "verify-email"
                ) {
                    router.push({ name: "dashboard" });
                } else if (account.role) {
                    if (
                        account.role.name === "Mahasiswa" &&
                        account.email_verified_at != null
                    ) {
                        if (profile === null && to.name != "account-settings") {
                            router.push({ name: "account-settings" });
                        }
                    }
                }
            }
        });
    } else if (
        to.name != "sign-in" &&
        to.name != "sign-in-google" &&
        to.name != "sign-up" &&
        to.name != "password-reset" &&
        to.name != "password-reset-submit" &&
        to.name != "afiliator" &&
        to.name != "afiliator-view"
    ) {
        router.push({ name: "sign-in" });
    }
    // Scroll page to top on every route change
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
    });
});

export default router;
